import React, {memo} from "react";
import {NearbyUsersModel} from "@/app/api/user";
import {useOutletContext} from "react-router-dom";
import {useMediaQuery} from "@/app/utils/custom_function";
import useDetailPlayerPage from "@/app/features/find_players/pages/detail_player_page/slice";

// Import view components
import DetailPlayerPageMobileView from "./components/detail_player_page_mobile_view";
import DetailPlayerPageDesktopView from "./components/detail_player_page_desktop_view";

/**
 * DetailPlayerPage component
 * Renders different views based on device type
 */
const DetailPlayerPage = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const user = useOutletContext<NearbyUsersModel>();
  const {state, createChat, goToCreateAMatch} = useDetailPlayerPage();

  // Show appropriate view based on device type
  return isDesktop 
    ? <DetailPlayerPageDesktopView 
        user={user} 
        hasLoading={state.hasLoading} 
        createChat={createChat} 
        goToCreateAMatch={goToCreateAMatch} 
      />
    : <DetailPlayerPageMobileView 
        user={user} 
        hasLoading={state.hasLoading} 
        createChat={createChat} 
        goToCreateAMatch={goToCreateAMatch} 
      />;
};

export default memo(DetailPlayerPage);